/* eslint-disable no-unused-vars */
import React from 'react';
import style from './clearAll.module.scss';
import cx from 'classnames';

export default function ClearAll({ clearAll }: { clearAll: () => void }) {
  return (
    <span
      className={cx(style.container, 'search-clear-all')}
      onClick={clearAll}
    >
      Очистить все
    </span>
  );
}
